export default __webpack_public_path__ + "static/media/no-data-found.3e18d3dd.svg";